import './App.css';
import useLocalStorage from 'use-local-storage';


const App = () => {
    const [theme, setTheme] = useLocalStorage('theme' ? 'dark': 'light')

    const themeSwitch = () => {
       const newTheme = theme === 'light' ? 'dark' : 'light';
        setTheme(newTheme)
    }

  return (
    <div className="app" data-theme={theme}>
        <div className='login'>
            <h1>Log in</h1>
            <div className='container'>
                <div className='top'>
                    <i className='fab fa-google'></i>
                    <i className='fab fa-facebook'></i>
                    <i className='fab fa-twitter'></i>
                    <i className='fab fa-github'></i>
                    <i className='fab fa-instagram'></i>
                </div>
                <p className='divider'>
                    <span>OR</span>
                </p>
                <form>
                    <label>E-mail</label>
                    <input type='email' placeholder='Enter your E-mail' />

                    <label>Password</label>
                    <input type='password' placeholder='Enter your password' />

                    <div className='remember'>
                        <input type='checkbox' checked='checked' />
                        <p>Remember me</p>
                    </div>

                    <button>Log In</button>
                </form>

                <div className='bottom'>
                    <p>Forgot Password ??</p>
                    <a href='/'>Reset password</a>
                </div>
                <p className='create'>Create Account</p>
            </div>
            <div className='theme__toggle'>
                <h2>Light Theme</h2>
                <i onClick={themeSwitch} class="fa-solid fa-toggle-off"></i>
            </div>
        </div>
    </div>
  )
}

export default App;
